<app-dialog
  #dialog
  [key]="'partner-user'"
  [action]="'partner-user'"
  [headerTheme]="'simple'"
  [title]="titulo"
  [appendTo]="'body'"
  [maxWidth]="'520px'">
  <!--
    `appAutoFormGroup` é OBRIGATÓRIO junto com o `[formGroup]`: o `app-input` não injeta
    `ControlContainer`, ele lê o grupo desta diretiva. Só com o `[formGroup]` os inputs
    criam controles PRÓPRIOS — a tela fica preenchida e `ng-valid`, e o formulário do
    componente continua vazio e inválido, com o botão salvar travado para sempre. Sem erro
    no console. Medido no navegador em 18/09/2026.
  -->
  <div class="p-4" [formGroup]="form" appAutoFormGroup>
    <div class="row">
      <div class="col-12 col-md-6">
        <app-input
          [type]="'text'"
          [label]="'Nome'"
          [placeholder]="'Nome'"
          [controlName]="'firstName'"
          [required]="true"></app-input>
      </div>
      <div class="col-12 col-md-6">
        <app-input
          [type]="'text'"
          [label]="'Sobrenome'"
          [placeholder]="'Sobrenome'"
          [controlName]="'surName'"
          [required]="true"></app-input>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <app-input
          [type]="'email'"
          [label]="'E-mail'"
          [placeholder]="'nome@empresa.com.br'"
          [controlName]="'email'"
          [required]="true"></app-input>

        <!--
          O motivo escrito, e não só o campo cinza: campo desabilitado sem explicação é
          chamado. O e-mail é o login e entra no hash do token de criação de senha, então
          trocá-lo depois invalidaria links em trânsito sem avisar ninguém.
        -->
        <small *ngIf="emailTravado" class="d-block mt-1 text-muted">
          Este usuário já criou a senha, então o e-mail de login não pode mais ser alterado.
        </small>
        <small *ngIf="!estaEditando" class="d-block mt-1 text-muted">
          É o login dele. Ele vai receber neste endereço um link para criar a senha.
        </small>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-md-6">
        <app-input
          type="useMask"
          [unmask]="true"
          mask="+99 (99) 99999-9999"
          placeholder="+55 (11) 99999-9999"
          [autoClear]="false"
          [label]="'Telefone'"
          [controlName]="'phoneNumber'"
          [required]="false"></app-input>
      </div>

      <!--
        Perfil só no cadastro. Na edição, mudar perfil é a ação "Promover para Master" do
        menu da linha, que tem confirmação própria — é irreversível, e não pode ficar
        escondida dentro de um "Salvar".
      -->
      <div *ngIf="!estaEditando" class="col-12 col-md-6">
        <app-select
          [label]="'Perfil'"
          [options]="opcoesDePerfil"
          [placeholder]="'Perfil'"
          formControlName="perfil"></app-select>
      </div>
    </div>

    <!--
      O que a tela NÃO pergunta, dito de frente: sem isto o master fica procurando onde
      escolhe empresas, e a resposta é que não escolhe — é herdado do parceiro.
    -->
    <div *ngIf="!estaEditando" class="row mt-3">
      <div class="col-12">
        <div class="alert alert-info mb-0" role="note">
          O usuário entra vinculado ao seu parceiro e enxerga as mesmas empresas que você.
          <strong>Comum</strong> vê apenas os deals que ele mesmo registrar;
          <strong>Master</strong> vê os deals de toda a equipe e administra esta tela.
        </div>
      </div>
    </div>

    <!--
      O aviso da irreversibilidade aparece só quando ele é relevante, e ANTES de gravar: o
      master escolhido aqui sai do alcance das ações desta tela, então o próprio parceiro não
      desfaz. Aparecer sempre viraria ruído e ninguém leria no dia em que importa.
    -->
    <div *ngIf="!estaEditando && perfilMasterSelecionado" class="row mt-3">
      <div class="col-12">
        <div class="alert alert-warning mb-0" role="alert">
          Depois de criado como Master, você não conseguirá editar, inativar nem rebaixar este
          usuário — só a Legatus. Na dúvida, cadastre como Comum: promover depois é um clique.
        </div>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="gravando"
        [loadingText]="estaEditando ? 'Salvando...' : 'Cadastrando...'"
        [label]="estaEditando ? 'Salvar' : 'Cadastrar'"
        [type]="'button'"
        (sendButtonClick)="submitAction()"></app-button>
    </div>
  </ng-template>
</app-dialog>
